import React, { useState } from "react";
import { trans } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import ErrorModal from "../../Fragments/ErrorModal";
import { Link } from "react-router-dom";
import { ArmenianFlagConst } from "../../UIComponents/UIComponents";
import Tab from "../../Fragments/Tab";
function InitMobileSteps(props) {
  const [_token, setToken] = useState(props.csrf_token.data);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [formResponse, setFormResponse] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [touched, setTouched] = useState(false);
  const [phoneValue, setPhoneValue] = useState(
    props.mobileConfig.mobileMsisdn || ""
  );
  const [emailValue, setEmailValue] = useState(
    props.mobileConfig.mobileMsisdn || ""
  );

  const phoneRegex = /^[1-9]\d{7}$/;
  const emailRegex = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

  const handleBlur = () => {
    setTouched(true);
  };

  const validateForm = () => {
    if (currentTabIndex === 0) {
      const phone = phoneValue.trim();
      return phone.length > 0 && phoneRegex.test(phone);
    } else {
      const email = emailValue.trim();
      return email.length > 0 && emailRegex.test(email);
    }
  };

  const checkMobilePrefix = (numberValue, isPhoneTab = true) => {
    let isMobile = "mobile";

    if (isPhoneTab && numberValue !== "") {
      const msisdnPfx = props.config.data.msisdn_pfx;
      for (let group in msisdnPfx) {
        let stop = false;
        for (let item in msisdnPfx[group]) {
          const prefixCurrent = msisdnPfx[group][item];
          const pattern = new RegExp("^" + prefixCurrent);

          if (prefixCurrent.length > 1 && pattern.test(numberValue)) {
            isMobile = group;
            stop = true;
            break;
          }
          if (prefixCurrent.length === 1 && pattern.test(numberValue)) {
            isMobile = group;
          }
        }
        if (stop) {
          break;
        }
      }
    }

    props.updateParentState({
      mobileMsisdn: numberValue,
      mobileMaxStep: isMobile === "fixed" ? 4 : 3,
      mobileTab: isPhoneTab ? isMobile : "mobile",
    });
  };

  const calcStepWidth = () => {
    return (
      (100 / props.mobileConfig.mobileMaxStep) * props.mobileConfig.mobileStep
    );
  };

  const reSendData = () => {
    setButtonDisabled(true);
    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        props.setTokenAction(resolve.data);
        setToken(resolve.data.data);
        sendData();
      },
      () => {
        setShowErrorModal(true);
      }
    );
  };

  const sendData = () => {
    setButtonDisabled(true);
    const currentValue = currentTabIndex === 0 ? phoneValue : emailValue;

    let prefix =
      currentTabIndex === 0
        ? props.mobileConfig.mobileTab === "mobile"
          ? "mob"
          : "fix"
        : "email";
    let payload = {
      _token: _token,
    };

    if (currentTabIndex === 0) {
      payload.msisdn = currentValue;
    } else {
      payload.email = currentValue;
    }

    ApiManager.postRequest(payload, "/register/" + prefix + "/request").then(
      (resolve) => {
        setButtonDisabled(false);
        setFormResponse(resolve.data);
        if (resolve.data.hasOwnProperty("token")) {
          props.updateParentState({
            mobileToken: resolve.data.token,
            mobileStep: 2,
            mobileTimeLife: resolve.data.data.time,
            currentTabIndex: currentTabIndex,
          });
        } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
          reSendData();
        }
      },
      () => {
        setShowErrorModal(true);
      }
    );
  };

  const errorModal = () =>
    showErrorModal ? (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={trans(props.trans, "error.modal.description")}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    ) : null;

  let msisdnErrorClass = "",
    msisdnErrorBox = "",
    errorBox = "";

  if (formResponse !== "") {
    if (formResponse.status === "INVALID_DATA") {
      if (
        formResponse.errors.hasOwnProperty("msisdn") ||
        formResponse.errors.hasOwnProperty("email")
      ) {
        msisdnErrorClass = " form-error";
        msisdnErrorBox = (
          <div className="form-error-text fs11">
            {currentTabIndex === 0
              ? formResponse.errors.msisdn
              : formResponse.errors.email}
          </div>
        );
      }
    }

    if (formResponse.status === "ERROR") {
      errorBox = (
        <FormMiddlewareError
          message={formResponse.message}
          trans={props.trans}
        />
      );
    }
  }

  const phoneEmpty = phoneValue.trim().length === 0;
  const emailEmpty = emailValue.trim().length === 0;

  const showPhoneError =
    touched &&
    currentTabIndex === 0 &&
    !phoneEmpty &&
    !phoneRegex.test(phoneValue.trim());
  const showEmailError =
    touched &&
    currentTabIndex === 1 &&
    !emailEmpty &&
    !emailRegex.test(emailValue.trim());

  return (
    <div className="form">
      <form
        action="#"
        method="post"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
          setTouched(true);

          if (!validateForm()) {
            return;
          }
          sendData();
        }}
      >
        <div className="form__form-box form-box">
          <div className="form__sub-title db fs11">
            {props.mobileConfig.mobileStep}{" "}
            {trans(props.trans, "auth.register.step.title")}{" "}
            {props.mobileConfig.mobileMaxStep}{" "}
            {trans(
              props.trans,
              "auth.register.step" + props.mobileConfig.mobileMaxStep
            )}
          </div>
          <div className="form__step-out">
            <div
              className="form__step"
              style={{ width: calcStepWidth() + "%" }}
            ></div>
          </div>
        </div>

        <div className={`form__form-box${msisdnErrorClass}`}>
          <label className="form__label db fs11" htmlFor="tel-number">
            {trans(props.trans, "auth.login.register.button.title")}
          </label>

          <Tab
            items={[
              {
                title: trans(props.trans, "auth.number.title"),
                content: (
                  <>
                    <label className="form__label db fs11" htmlFor="tel-number">
                      {trans(props.trans, "auth.login.number.label")}
                    </label>
                    <div className="form__field-out form__field-out--with-prefix pr">
                      <div
                        className="form__field-out pr"
                        style={{ display: "flex" }}
                      >
                        <ArmenianFlagConst />
                        <input
                          className="form__field form__field--right-space fs13"
                          id="tel-number"
                          disabled={buttonDisabled}
                          style={{
                            border: "none",
                            borderRadius: "0",
                            borderBottom: "1px solid #ccc",
                            paddingLeft: 10,
                          }}
                          name="tel-number"
                          type="text"
                          placeholder={trans(
                            props.trans,
                            "auth.register.phone.placeholder1"
                          )}
                          onBlur={handleBlur}
                          onChange={(event) => {
                            const value = event.target.value
                              .trim()
                              .replace(/[^\d]/g, "");
                            setPhoneValue(value);
                            checkMobilePrefix(value, true);
                          }}
                          value={phoneValue}
                        />
                        <div className="form__info-box pa">
                          <button
                            className="form__info sprite"
                            type="button"
                          ></button>
                          <div className="form__info-txt fs11 pa">
                            {trans(props.trans, "auth.register.phone.hint1")}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ),
                clickCallback: () => {
                  setCurrentTabIndex(0);
                  setTouched(false);
                  props.updateParentState({
                    currentTabIndex: 0,
                    mobileMsisdn: phoneValue,
                  });
                },
              },
              {
                title: trans(props.trans, "auth.email.title"),
                content: (
                  <>
                    <div className="form__field-out form__field-out--with-prefix pr">
                      <input
                        className="form__field form__field--right-space fs13"
                        id="email-field"
                        name="email-field"
                        type="email"
                        disabled={buttonDisabled}
                        style={{
                          paddingLeft: 10,
                        }}
                        placeholder={trans(
                          props.trans,
                          "auth.login.email.placeholder"
                        )}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          const value = event.target.value.trim();
                          setEmailValue(value);
                          checkMobilePrefix(value, false);
                        }}
                        value={emailValue}
                      />
                      <div className="form__info-box pa">
                        <button
                          className="form__info sprite"
                          type="button"
                        ></button>
                        <div className="form__info-txt fs11 pa">
                          {trans(props.trans, "auth.register.phone.hint1")}
                        </div>
                      </div>
                    </div>
                  </>
                ),
                clickCallback: () => {
                  setCurrentTabIndex(1);
                  setTouched(false);
                  props.updateParentState({
                    currentTabIndex: 1,
                    mobileMsisdn: emailValue,
                  });
                },
              },
            ]}
            index={currentTabIndex}
          />
          {msisdnErrorBox}
          {(touched && currentTabIndex === 0 && phoneEmpty) ||
          (touched && currentTabIndex === 1 && emailEmpty) ? (
            <div
              className="form-error-text fs11"
              style={{ marginTop: "5px", color: "red" }}
            >
              {trans(props.trans, "field.required")}
            </div>
          ) : null}
          {showPhoneError && (
            <div
              className="form-error-text fs11"
              style={{ marginTop: "5px", color: "red" }}
            >
              {trans(props.trans, "auth.login.validation.number")}
            </div>
          )}
          {showEmailError && (
            <div
              className="form-error-text fs11"
              style={{ marginTop: "5px", color: "red" }}
            >
              {trans(props.trans, "auth.login.validation.email")}
            </div>
          )}
        </div>

        {errorBox}

        <button
          className={`form__submit-btn btn btn--with-space btn--yellow fs17${
            buttonDisabled ? " btn--loading" : ""
          }`}
          type="submit"
          disabled={buttonDisabled}
        >
          {trans(
            props.trans,
            "auth.register.phone.button.title1_mobile"
          )}
        </button>
        <Link
          className="form__submit-btn btn btn--white db fs17"
          to={config.urlPrefix}
        >
          {trans(props.trans, "auth.register.phone.button.cancel")}
        </Link>
      </form>
      {errorModal()}
    </div>
  );
}

export default InitMobileSteps;
